export const situationsOne = [
  {
    id: 1,
    text: "One of the Jawan has deserted from the unit with the daughter of class four civilian employee of your unit.  All the class four employees threaten to go on strike if the daughter of the concerned employee is not restored and appropriate disciplinary action is not initiated against the Jawan. As CO of unit you will...",
    response:
      " Directed CMP to search and investigate, initiated disciplinary action and assured employees safe return of girl. ",
  },
  {
    id: 2,
    text: "You are in charge to board your old grandfather to Chennai. While settling down and before a few minutes to start the train, you notice that boarded on Madurai express instead of Chennai express. You...",
    response:
      "Immediately took luggage, asked TTE for platform no of Chennai express and boarded the train.",
  },
  {
    id: 3,
    text: " You got high package job in a foreign country which is a one time opportunity, but your sick mother wants to be here and do a local job. You...",
    response: "Convinced mother to come with me and took good care of her.",
  },
  {
    id: 4,
    text: "You feel yourself legal and because of this you find your view and opinion is not accepted by others or at work, you...",
    response:
      "Listened and respected other’s opinions and tried presenting myself in a more friendly manner.",
  },
  {
    id: 5,
    text: "He was swimming in the middle of the canal when a sudden cramp in the leg made him helpless. He looked around for help but there was none in sight. Seeing a buffalo approaching towards him, he...",
    response: "Jumped on the buffalo and came out of the canal.",
  },
  {
    id: 6,
    text: "A very important meeting is to take place in your office at 10.30 AM. The papers related to the meeting are in your almirah in the office, and the keys are with you. But you are caught in the traffic jam caused by the procession of a political party. You...",
    response:
      "He informed the secretary to start the briefing, meanwhile he took another way, reached office and attended the meeting. ",
  },
  {
    id: 7,
    text: "You are going to a friend’s reception by wearing a new dress on the bike, while near to the reception hall in a road signal, a person spits on your pant from the bus. You...",
    response: "Found a public washroom and cleaned the pant.",
  },
  {
    id: 8,
    text: "Your uncle brough all your property illegally and your father is working hard to support your family but he couldn’t, as a responsible son what you will do...",
    response:
      "Took a  job, helped the family financially, and lodge a complaint against the uncle.",
  },
  {
    id: 9,
    text: "As a member of the college sports board, he was in charge of selecting students for the team, at that time his professor approach him for selecting his son into the team, while he handles a subject with practical for him. He...",
    response:
      "Told him the impartiality of selection procedure, told him to keep faith in his son and made the selection on merit.",
  },
  {
    id: 10,
    text: "You are on your morning jogging, on the way you saw an old man cleaning his buffalo in the river, got struggling along With buffalo to come out of heavy water current. You don’t know swimming, you will...",
    response:
      "Take a branch of a tree and lured the buffalo to come out of the water current and helped the old man too.",
  },
  {
    id: 11,
    text: "You are a newly posted lieutenant, and it’s an emergency but your seniors are giving wrong orders and implementing it may lead to loss of your team members life. You...",
    response:
      "Informed seniors about the consequences, proposed an alternate plan, convinced them and acted on it.",
  },
  {
    id: 12,
    text: "You are going to Darjeeling, where your family mates want to take a photograph on the lawn where entry is prohibited. But they are looking sad because of that denial. You...",
    response: "Took them to another lawn where photography is permitted.",
  },
  {
    id: 13,
    text: "He is passing by a railway line and saw that the fishplates have been removed. Only 15 mins are left for the train to reach and the station is 1.5 km away from the spot. He...",
    response:
      "He contacted the nearest station via phone, detailed them about the situation and got the train stopped.",
  },
  {
    id: 14,
    text: "Your brother who got selected for the state level table tennis tournament left the home to railway station without the bat. You notice and rush to the station without taking license and traffic police make you wait and enquire. You...",
    response:
      "I apologized, informed about urgency, paid fine and went to the railway station and gave bat.",
  },
  {
    id: 15,
    text: "You are in love with a girl while studying engineering and you both study well to get a good job, later you came to know that her father was responsible to make your father's business let down. You will...",
    response:
      "Both together meet each other's parents, express their feelings, remove grudges, if any, and convinced them.",
  },
  {
    id: 16,
    text: "While using a common washing machine in his college hostel, he noticed that shock is coming from the socket of the machine and while he finished his work and about to leave. He...",
    response:
      "Unplugged the machine, informed warden and others and got it repaired.",
  },
  {
    id: 17,
    text: "He is newly appointed captain of a big cargo ship and on the trail, he loses his communication with the coast and it's about to lose whole steadiness because of failure of the communication device. He...",
    response:
      "Stopped the ship, directed engineer-in-chief to find the issue and re-establish the communication.",
  },
  {
    id: 18,
    text: "A new family settled in your neighbor imports smuggled goods, and your wife wants to purchase it for your house at a cheaper rate. You will...",
    response:
      "Told her about the authenticity of the product, assured to buy from the market and convinced not to buy smuggled good.",
  },
  {
    id: 19,
    text: "Your team leader corners you many times before your group and while lunchtime discussion, everyone talks badly about team leader in his absence by supporting you. You will...",
    response: "Take it lightly and focused on improving the performance.",
  },
  {
    id: 20,
    text: "Only three days are left for final project submission, but the teammate who knows most of the modules left the team in some issue. You will...",
    response:
      "Gathered team members, held talk, removed misunderstanding and convinced all to work together.",
  },
  {
    id: 21,
    text: "He felt that the leave policy being followed in the Company was not proper...",
    response:
      " He read the company rules and if found discrepancies wrote an application to HR",
  },
  {
    id: 22,
    text: "On entering the train compartment he found a lady occupying his reserved seat. He...",
    response:
      "He showed his ticket, politely asked her to vacant and helped the lady find her seat.",
  },
  {
    id: 23,
    text: "You did something wrong what you shouldn't have done. You...",
    response:
      "Tried to correct the things, made confession and promised not to repeat.",
  },
  {
    id: 24,
    text: " You are a horse rider. Once the horse went out of control. You...",
    response:
      "Ease up on both reins, gave horse command to slow and pulled on side of rein to stop the horse.",
  },
  {
    id: 25,
    text: "The appointed day of his sister's wedding had arrived but his father was held up in U K. He...",
    response:
      "Took the responsibility, made all arrangements and attended father wedding on the video call.",
  },
  {
    id: 26,
    text: "The sea was very rough and it was night. Ship duty officer fell in the sea while taking a round. What you do...",
    response:
      "Alarmed crew members, directed divers to rescue and threw life jacket into the sea and saved the ship, duty officer.",
  },
  {
    id: 27,
    text: "Four of them decided to go on foot from Dehradoon to Mussoorie but that day it started raining and they were told the slopes of the mountains would be slippery. So he...",
    response: "Postponed the trip and planned for another day. ",
  },
  {
    id: 28,
    text: "While choosing his/her life partner, his/her criteria of selection will be...",
    response: "Compatibility, intelligence, and maturity.",
  },
  {
    id: 29,
    text: "You feel that world can move towards peace if...",
    response:
      "Non-proliferation of nuclear weapons is signed by all countries.",
  },
  {
    id: 30,
    text: " He/She thinks that he/she is more intelligent. Give reasons...",
    response:
      "Critically analyses situation well and make a quick decision at the time of crisis.",
  },
  {
    id: 31,
    text: "While going to a place, he found the only bus left was full and no other public transport was available. He...",
    response: "He took the ticket and went by standing on the bus.",
  },
  {
    id: 32,
    text: "He was passing through a jungle. It was getting dark when he heard some noise in the bushes behind him. He...",
    response:
      "He kept calm, fastened his pace, and reached a safe place, analyzed the situation and acted accordingly..",
  },
  {
    id: 33,
    text: "On the last day of application the clerk refused to accept his application as one testimonial found unattested. He...",
    response:
      "He immediately got it attested and handed over to clerk with complete documents. ",
  },
  {
    id: 34,
    text: "While going to the examination hall, he reached half an hour late due to some unavoidable circumstances. Invigilator refused him to appear in the examination. He...",
    response:
      " He went to the controller of examination, told the reason of being late, convinced him and gave the exam.",
  },
  {
    id: 35,
    text: "He as a captain of school football team found that members of the team did not turn up for practice. He...",
    response:
      "Called team meeting, inquired the reason and took action if found to be ineffective.",
  },
  {
    id: 36,
    text: "When he had just done his B.Sc in Ist Division, he was still without a job, one of his equally penniless friends needed coaching. He...",
    response:
      "He joined a call center, prepared for government exam, and helped his friend in taking education loan..",
  },
  {
    id: 37,
    text: "His poor parents had educated him up to BA bearing lots of hardships. He keenly felt he must quickly get a job to help his family but was not getting any suitable job. He...",
    response:
      "He started giving tuitions, supported family, prepared for government exams and got the job.",
  },
  {
    id: 38,
    text: "His elder brother wanted to celebrate the death of their very old father but he felt otherwise. He...",
    response:
      "He took the opinions of other members of the family and acted accordingly.",
  },
  {
    id: 39,
    text: "After many efforts, he got a job in a private firm but his office was very far off from his house and there was no transport facility. He...",
    response: "Rented a room near office.",
  },
  {
    id: 40,
    text: "While trekking in a knee-deep snow his left foot slipped and he fell into a deep ditch. He cried for help but none was near. He...",
    response:
      "He remained calm, climbed up with help of snow axe and reached the top safely.",
  },
  {
    id: 41,
    text: "His father was returning victorious from the war and he had gone to receive him at the Railway Station. As he was waiting he heard a loud explosion. He...",
    response:
      "Immediately informed RPF, searced his father and helped in handling the situation in any way possible.",
  },
  {
    id: 42,
    text: "During floods in his village he found that the people have moved away with their belongings leaving the animals behind. He...",
    response:
      "Took the help of local authority and ensured the safety of the animals.",
  },
  {
    id: 43,
    text: "He happened to be at the Railway Platform when a stranger slipped from a slow-moving train injuring himself badly. He..",
    response:
      "He admitted him to railway hospital and informed family members.",
  },
  {
    id: 44,
    text: "He felt that the preparatory holidays were not enough for their final exam because he had fallen ill. He...",
    response:
      "Motivated himself, studied strategically and gave his best in the exam.",
  },
  {
    id: 45,
    text: "As a monitor of his class he had to put up the names of those who had not done their homework. His friend was also a culprit. He...",
    response: "He wrote names of the defaulter and put up on notice board. ",
  },
  {
    id: 46,
    text: "A charity show was arranged for national defence fund and people had contributed liberally. But at the showtime, the leading artist failed to turn up. As the Secretary of the society, he...",
    response:
      "Told the host to keep the audience engaged meanwhile contacted the artist and made him available.",
  },
  {
    id: 47,
    text: "Once he was in charge of school library shifting operation from ground floor to 3rd floor when all of a sudden the lift failed in its upward movement in between the floors. He...",
    response:
      "He pressed the alarm button, informed security, got lift repaired and completed shifting.",
  },
  {
    id: 48,
    text: "A few refugees attacked him while he was distributing rations in a refugee camp. He...",
    response:
      " He immediately called security, got them arrested and continued distribution of rations",
  },
  {
    id: 49,
    text: "He urgently had to reach a neighboring village on a dark night. He had no weapon nor any companion to take with him. He...",
    response: "He took a public transport and reached the village safely.",
  },
  {
    id: 50,
    text: "Having been brought up in the village, his knowledge of English was poor. When he got admission into the engineering college he was uncertain whether he will be able to get along and therefore, he...",
    response:
      "He learned Basic English from the internet and gradually made himself comfortable.",
  },
  {
    id: 51,
    text: "There was a dispute between two of her friends and they wanted her as a mediator, she had to go out for an urgent work of her father. She...",
    response:
      "Told them about the urgency and helped in mediation after return from work. ",
  },
  {
    id: 52,
    text: "In the circus show two lions went out of control and jumped into the crowd. She...",
    response:
      "Immediately evacuated the place and called animal control and ambulance.",
  },
  {
    id: 53,
    text: "Her aunt often badmouthed her mother. She...",
    response: "Talked to uncle about her behavior.",
  },
  {
    id: 54,
    text: "He learned that his parents were not getting along. He...",
    response:
      "Arranged a family intervention, talked to them, removed their grudges  and booked them a holiday trip.",
  },
  {
    id: 55,
    text: "You are on a school trip with your friends when a boy/girl from your group asked you for a date but you are already in a relationship. You would...",
    response: "Told about my relationship status and convinced to be friends. ",
  },
  {
    id: 56,
    text: "You come to know that your father who is serving in a war is held as POW. You...",
    response:
      "Keep in touch with the embassy, supported mother emotionally and try to keep in touch with father till he returns.",
  },
  {
    id: 57,
    text: "Your newly married brother want separation from the family which made your parents deeply sad. You would...",
    response: "Talked to my brother, and convinced them for the stay.",
  },
  {
    id: 58,
    text: "You are education minister of India, What drastic changes would you make...",
    response:
      "Introduction of human rights subject and setting up infrastructure for imparting practical knowledge.",
  },
  {
    id: 59,
    text: "You saw your younger sister's profile on a dating app. What would you do...",
    response: "Talked to her and suggested her to engage in real life..",
  },
  {
    id: 60,
    text: "You are a cadet in a military academy and your seniors often punish you and your term mates rigorously for silly mistakes. You would...",
    response: "Stopped committing silly mistakes and learned for the ragda.",
  },
  {
    id: 60,
    text: "You are a cadet in a military academy and your seniors often punish you and your term mates rigorously for silly mistakes. You would...",
    response: "Stopped committing silly mistakes and learned from the ragda.",
  },
];
